import { render, staticRenderFns } from "./specialClassify.vue?vue&type=template&id=3c406c68&"
import script from "./specialClassify.vue?vue&type=script&lang=js&"
export * from "./specialClassify.vue?vue&type=script&lang=js&"
import style0 from "./specialClassify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports